export const TAJIKISTAN_ATTRACTIONS = [
  {
    id: "iskanderkul",
    emoji: "🏔️",
    name: {
      ru: "Искандеркуль",
      tj: "Искандаркӯл",
      en: "Iskanderkul",
    },
    desc: {
      ru: "Живописное горное озеро в Фанских горах на высоте 2 195 м над уровнем моря",
      tj: "Кӯли кӯҳии зебо дар Кӯҳҳои Фан дар баландии 2 195 м аз сатҳи баҳр",
      en: "Scenic mountain lake in the Fann Mountains at 2,195 m above sea level",
    },
    region: {
      ru: "Согдийская область",
      tj: "Вилояти Суғд",
      en: "Sughd Region",
    },
  },
  {
    id: "hissar",
    emoji: "🏯",
    name: {
      ru: "Гиссарская крепость",
      tj: "Қалъаи Ҳисор",
      en: "Hissar Fortress",
    },
    desc: {
      ru: "Древняя крепость XVIII века близ Душанбе — памятник средневековой архитектуры Центральной Азии",
      tj: "Қалъаи қадимии асри XVIII дар наздикии Душанбе — ёдгории меъмории асримиёнагии Осиёи Марказӣ",
      en: "Ancient 18th-century fortress near Dushanbe — a monument of medieval Central Asian architecture",
    },
    region: {
      ru: "Близ Душанбе",
      tj: "Наздикии Душанбе",
      en: "Near Dushanbe",
    },
  },
  {
    id: "pamir",
    emoji: "🛣️",
    name: {
      ru: "Памирский тракт",
      tj: "Роҳи Помир",
      en: "Pamir Highway",
    },
    desc: {
      ru: "Одна из самых высокогорных дорог мира (М41), проходящая через величественный Памир",
      tj: "Яке аз баландтарин роҳҳои ҷаҳон (М41), ки тавассути Помири бошукӯҳ мегузарад",
      en: "One of the world's highest roads (M41), crossing the majestic Pamir plateau",
    },
    region: {
      ru: "Горно-Бадахшанская АО",
      tj: "ВМКБ",
      en: "Gorno-Badakhshan",
    },
  },
  {
    id: "fann-mountains",
    emoji: "⛰️",
    name: {
      ru: "Фанские горы",
      tj: "Кӯҳҳои Фан",
      en: "Fann Mountains",
    },
    desc: {
      ru: "Горный массив с кристально чистыми озёрами, ледниками и маршрутами для треккинга мирового уровня",
      tj: "Кӯҳистон бо кӯлҳои тозаву зебо, пиряхҳо ва масирҳои пиёдагардии дараҷаи ҷаҳонӣ",
      en: "Mountain range with crystal-clear lakes, glaciers and world-class trekking routes",
    },
    region: {
      ru: "Согдийская область",
      tj: "Вилояти Суғд",
      en: "Sughd Region",
    },
  },
  {
    id: "nurek",
    emoji: "💧",
    name: {
      ru: "Нурекское водохранилище",
      tj: "Обанбори Норак",
      en: "Nurek Reservoir",
    },
    desc: {
      ru: "Одно из крупнейших водохранилищ Центральной Азии у подножия высокогорной плотины",
      tj: "Яке аз бузургтарин обанборҳои Осиёи Марказӣ дар пои сарбанди баландкӯҳ",
      en: "One of Central Asia's largest reservoirs at the foot of a high-altitude dam",
    },
    region: {
      ru: "Хатлонская область",
      tj: "Вилояти Хатлон",
      en: "Khatlon Region",
    },
  },
  {
    id: "penjikent",
    emoji: "🏛️",
    name: {
      ru: "Древний Пенджикент",
      tj: "Панҷакенти Қадим",
      en: "Ancient Penjikent",
    },
    desc: {
      ru: "Руины согдийского города V–VIII вв. н.э. — «Помпеи Центральной Азии» с уникальными фресками",
      tj: "Харобаҳои шаҳри суғдии асрҳои V–VIII — «Помпеяи Осиёи Марказӣ» бо нақшҳои беназир",
      en: "Ruins of a 5th–8th century Sogdian city — the 'Pompeii of Central Asia' with unique frescoes",
    },
    region: {
      ru: "Согдийская область",
      tj: "Вилояти Суғд",
      en: "Sughd Region",
    },
  },
  {
    id: "karakul",
    emoji: "🌊",
    name: {
      ru: "Озеро Каракуль",
      tj: "Кӯли Қорақӯл",
      en: "Karakul Lake",
    },
    desc: {
      ru: "Высокогорное озеро на Памире на высоте 3 914 м — одно из самых высоких озёр мира",
      tj: "Кӯли баландкӯҳ дар Помир дар баландии 3 914 м — яке аз баландтарин кӯлҳои ҷаҳон",
      en: "High-altitude lake in the Pamir at 3,914 m — one of the world's highest lakes",
    },
    region: {
      ru: "Горно-Бадахшанская АО",
      tj: "ВМКБ",
      en: "Gorno-Badakhshan",
    },
  },
  {
    id: "yagnob",
    emoji: "🌄",
    name: {
      ru: "Долина Ягноб",
      tj: "Водии Яғноб",
      en: "Yagnob Valley",
    },
    desc: {
      ru: "Уединённая горная долина, где сохранился живой согдийский язык и традиционный уклад жизни",
      tj: "Водии кӯҳии дурдаст, ки забони зиндаи суғдӣ ва тарзи зиндагии анъанавӣ дар он нигоҳ дошта шудааст",
      en: "Remote mountain valley where the living Sogdian language and traditional way of life are preserved",
    },
    region: {
      ru: "Согдийская область",
      tj: "Вилояти Суғд",
      en: "Sughd Region",
    },
  },
  {
    id: "khujand",
    emoji: "🕌",
    name: {
      ru: "Худжанд",
      tj: "Хуҷанд",
      en: "Khujand",
    },
    desc: {
      ru: "Один из древнейших городов Центральной Азии, основанный Александром Македонским более 2 500 лет назад",
      tj: "Яке аз қадимтарин шаҳрҳои Осиёи Марказӣ, ки Искандари Мақдунӣ зиёда аз 2 500 сол пеш бунёд кардааст",
      en: "One of Central Asia's oldest cities, founded by Alexander the Great over 2,500 years ago",
    },
    region: {
      ru: "Согдийская область",
      tj: "Вилояти Суғд",
      en: "Sughd Region",
    },
  },
  {
    id: "tigrovaya-balka",
    emoji: "🐅",
    name: {
      ru: "Заповедник «Тигровая балка»",
      tj: "Қӯриқхонаи «Бибишир»",
      en: "Tigrovaya Balka Reserve",
    },
    desc: {
      ru: "Уникальный природный заповедник в пойме Амударьи с богатым миром тугайных лесов и птиц",
      tj: "Қӯриқхонаи табиии беназир дар доманаи Амударё бо ҷаҳони сарсабзи ҷангалҳо ва паррандаҳо",
      en: "Unique nature reserve in the Amu Darya floodplain with rich tugai forests and birdlife",
    },
    region: {
      ru: "Хатлонская область",
      tj: "Вилояти Хатлон",
      en: "Khatlon Region",
    },
  },
];
